import { LitElement, html, css } from "lit";
import { customElement, property } from "lit/decorators.js";
import { Toast } from "../models";

/**
 * Renders a collection of toast notifications.
 */
@customElement("bab-toast-manager")
export class BabToastManager extends LitElement {
  static styles = css`
    :host {
      position: fixed;
      bottom: 24px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 1000;
      display: flex;
      flex-direction: column;
      gap: 8px;
      pointer-events: none;
    }

    .toast {
      padding: 10px 20px;
      background: var(--bab-card-bg);
      color: var(--bab-text);
      border: var(--bab-border-width, 1.5px) solid var(--bab-border);
      border-radius: var(--bab-radius, 12px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      font-size: 0.875rem;
      font-weight: 500;
      display: flex;
      align-items: center;
      gap: 8px;
      animation: toast-in 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
      transition: opacity 0.2s, transform 0.2s;
      pointer-events: auto;
    }

    .toast--success {
      border-left: 4px solid #22c55e;
    }

    .toast--info {
      border-left: 4px solid var(--bab-accent, #4a90e2);
    }

    @keyframes toast-in {
      from { opacity: 0; transform: translateY(20px); }
      to { opacity: 1; transform: translateY(0); }
    }

    svg {
      flex-shrink: 0;
    }
  `;

  @property({ type: Array })
  toasts: Toast[] = [];

  render() {
    return html`
      ${this.toasts.map(
        (t) => html`
          <div class="toast toast--${t.type === "warn" ? "info" : t.type}">
            ${t.type === "success"
              ? html`<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>`
              : html`<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>`}
            ${t.message}
          </div>
        `,
      )}
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bab-toast-manager": BabToastManager;
  }
}
